import instance from "./Instance/index.js";

export const createCertificate = async (values) => {
  try {
    const response = await instance.post("/certificates", values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUserCertificates = async (id) => {
  try {
    const response = await instance.get(`/certificates/user/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getCertificate = async (id) => {
  try {
    const response = await instance.get(`/certificates/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const downloadCertificate = async (values) => {
  try {
    const response = await instance.post("/certificates/download/certificate", values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteCertificate = async (id) => {
  try {
    const response = await instance.delete(`/certificates/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};
